
// Chart data for the admin statistics page
export const userData = {
  labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun"],
  datasets: [
    {
      label: "Total de Usuários",
      data: [150, 220, 280, 320, 390, 427],
      borderColor: "rgb(59, 130, 246)",
      backgroundColor: "rgba(59, 130, 246, 0.1)",
      tension: 0.3,
      fill: true,
    },
    {
      label: "Usuários Premium",
      data: [50, 90, 120, 150, 180, 216],
      borderColor: "rgb(139, 92, 246)",
      backgroundColor: "rgba(139, 92, 246, 0.1)",
      tension: 0.3,
      fill: true,
    },
  ],
};

export const predictionsData = {
  labels: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"],
  datasets: [
    {
      label: "Palpites Milhar",
      data: [580, 620, 740, 650, 890, 850, 480],
      backgroundColor: "rgba(59, 130, 246, 0.7)",
    },
    {
      label: "Palpites Centena",
      data: [520, 580, 690, 590, 820, 790, 430],
      backgroundColor: "rgba(139, 92, 246, 0.7)",
    },
    {
      label: "Palpites Grupo",
      data: [320, 380, 420, 390, 510, 480, 320],
      backgroundColor: "rgba(16, 185, 129, 0.7)",
    },
  ],
};

export const revenueData = {
  labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun"],
  datasets: [
    {
      label: "Receita (R$)",
      data: [12500, 15800, 19200, 22500, 27800, 32100],
      borderColor: "rgb(16, 185, 129)",
      backgroundColor: "rgba(16, 185, 129, 0.1)",
      tension: 0.3,
      fill: true,
    },
  ],
};

// Convert data format for recharts
export const formattedUserData = userData.labels.map((month, index) => ({
  name: month,
  "Total de Usuários": userData.datasets[0].data[index],
  "Usuários Premium": userData.datasets[1].data[index],
}));

export const formattedPredictionsData = predictionsData.labels.map((day, index) => ({
  name: day,
  "Palpites Milhar": predictionsData.datasets[0].data[index],
  "Palpites Centena": predictionsData.datasets[1].data[index],
  "Palpites Grupo": predictionsData.datasets[2].data[index],
}));

export const formattedRevenueData = revenueData.labels.map((month, index) => ({
  name: month,
  "Receita (R$)": revenueData.datasets[0].data[index],
}));
